import { getEditLocation } from "../../../core/util/functions";
export const tradingDataLocation = "/cliring/referenceprices";
export const getTradingDataEditLocation = (id?: string) =>
  getEditLocation(tradingDataLocation, undefined, id);

export const editRouter = getTradingDataEditLocation(":ptdId?");
